<label *ngFor="let item of state.items">
    <div>
        <input type="checkbox" (click)="state.refine(item.value)" [checked]="item.isRefined"> {{ item.label }} ({{
        item.count }})
    </div>
</label>